
export const WebsocketEvent = {
  BATCH_INFO: 'batchInfo',
  JOB_ADD: 'jobAdd',
  JOB_UPDATE: 'jobUpdate',
  JOB_BATCH: 'jobBatch',
  JOB_DELETE: 'jobDelete',
  DEVICE_ADD: 'deviceAdd',
  DEVICE_UPDATE: 'deviceUpdate',
  DEVICE_DELETE: 'deviceDelete',
  CONFIGURATION_UPDATE: 'configurationUpdate',
  CHARGE_ADD: 'chargeAdd',
  CHARGE_UPDATE: 'chargeUpdate',
  CHARGE_DELETE: 'chargeDelete',
  DISCHARGE_ADD: 'dischargeAdd',
  DISCHARGE_UPDATE: 'dischargeUpdate',
  DISCHARGE_DELETE: 'dischargeDelete',
  MATERIAL_ASSIGN: 'materialAssign',
  MATERIAL_REASSIGN: 'materialReassign',
  MATERIAL_UNASSIGN: 'materialUnassign',
  MATERIAL_ADD: 'materialAdd',
  MATERIAL_UPDATE: 'materialUpdate',
  MATERIAL_DELETE: 'materialDelete',
  INVENTORY_ITEM_CHANGE: 'inventoryItemChange',
  MIX_PARAM_ADD_UPDATE: 'mixParamAddUpdate',
  EXTRA_PRODUCT_PARAM_ADD_UPDATE: 'extraProductParamAddUpdate',
  ADJUSTED_MIX_ADD: 'adjustedMixAdd',
  ADJUSTED_MIX_UPDATE: 'adjustedMixUpdate',
  ADJUSTED_MIX_DELETE: 'adjustedMixDelete',
  ITEM_ADD: 'itemAdd',
  ITEM_UPDATE: 'itemUpdate',
  ITEM_DELETE: 'itemDelete',
  CUSTOMER_ADD: 'customerAdd',
  CUSTOMER_UPDATE: 'customerUpdate',
  CUSTOMER_DELETE: 'customerDelete',
  PROJECT_ADD: 'projectAdd',
  PROJECT_UPDATE: 'projectUpdate',
  PROJECT_DELETE: 'projectDelete',
  EMPLOYEE_ADD: 'employeeAdd',
  EMPLOYEE_UPDATE: 'employeeUpdate',
  EMPLOYEE_DELETE: 'employeeDelete',
  TRUCK_ADD: 'truckAdd',
  TRUCK_UPDATE: 'truckUpdate',
  TRUCK_DELETE: 'truckDelete',
  TOKEN_EXPIRATION_ALERT: 'tokenExpirationAlert',
  TICKET_TEMPLATE_ADD: 'ticketTemplateAdd',
  TICKET_TEMPLATE_UPDATE: 'ticketTemplateUpdate',
  TICKET_TEMPLATE_DELETE: 'ticketTemplateDelete',
  ORDER_ADJUSTED_MIX_ADD: 'orderAdjustedMixAdd',
  ORDER_ADJUSTED_MIX_UPDATE: 'orderAdjustedMixUpdate',
  ORDER_ADJUSTED_MIX_DELETE: 'orderAdjustedMixDelete',
  BATCH_TICKET_UPDATE: 'batchTicketUpdate',
  BATCH_TICKET_ADD: 'batchTicketAdd',
  BATCH_TICKET_DELETE: 'batchTicketDelete',
  BIN_AUTO_TUNING: 'binAutoTuning',
  ML_MODEL_UPDATE: 'mlModelUpdate',
};
